import { inject } from '@angular/core';

import { AuthService } from '@echospaces-web-monorepo/es-auth';

/**
 * Customer-Super-Admin role marker. Customers' org-scoped Keycloak role
 * (NOT the echospaces-staff realm role — that one lives in admin-spa).
 * The same string `super-admin` is reused on both planes; we treat the
 * presence of the role on the JWT's `realm_access.roles` (mapped by
 * AuthService) as authoritative.
 */
export const SUPER_ADMIN_ROLE = 'super-admin';

/**
 * `true` when the current user holds `super-admin`. Pure read off the
 * AuthService signal — safe to call in computed signals and guards.
 */
export function isSuperAdmin(auth = inject(AuthService)): boolean {
  return auth.user()?.roles.includes(SUPER_ADMIN_ROLE) ?? false;
}
